// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"Leaderboard_noScrolling__X2SsF","leaderboardContainer":"Leaderboard_leaderboardContainer__UyhrC"};